"use client";

import { useState } from "react";
import NameSearchModal from "./name-search-modal";

// Small client wrapper around NameSearchModal's open/close state — Navbar
// (the server component that renders this) can't hold useState itself.
export default function NameSearchTrigger({ className }: { className?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={className ?? "text-sm font-semibold px-3 py-1.5 rounded-lg text-purple-200 hover:text-white hover:bg-purple-700 transition"}
        aria-label="Search names"
      >
        🔍 Search
      </button>
      {open && <NameSearchModal onClose={() => setOpen(false)} />}
    </>
  );
}
